module.exports = __webpack_public_path__ + "img/colordrop-jp.fe6df2e.jpg";